export default function genererMaterielType() {
  return {
    libelle: '',
    numerique: false,
    couleur: null,
  };
}
